const data = {
    printingColors: ["1 Colour", "2 Colour", "4 Colour", "5 Colour", "6 Colour"],
	printingType: [{name : "Offset Printing", value: "Offset"}, {name: "Flexographic Printing", value: "Flexo"}, {name: "Screen Printing", value: "Screen"}],
	printingSides: ["1", "2", "3", "4", "5", "6" ],
	printingSpecialColors: ["0 Colour", "1 Colour", "2 Colour", "4 Colour", "5 Colour", "6 Colour"],
}

export default data